import { icons } from './icons'
const menu = [
  {
    type: 'divider',
    name: 'Din verksamhet'
  },
  {
    type: 'link',
    icon: 'fa-home',
    title: 'Översikt',
    link: '#!/dashboard',
    active_key: 'dashboard'
  },
  {
    type: 'link',
    icon: 'fa-briefcase',
    title: 'Företag',
    link: '#!/company',
    active_key: 'company'
  },
  {
    type: 'link',
    icon: 'fa-layer-group',
    title: 'Objekt',
    active_key: 'entity/',
    link: '#!/entity/overview'
  },
  {
    type: 'link',
    icon: 'fa-address-book',
    title: 'Hyresgäster',
    link: '#!/tenant/overview',
    active_key: 'tenant/'
  },
  {
    type: 'link',
    icon: 'fa-key',
    title: 'Uthyrningar',
    link: '#!/lease/overview',
    active_key: 'lease',
  },
  {
    type: 'divider',
    name: 'Ekonomi'
  },
  {
    type: 'collapsable',
    icon: 'fa-file-invoice',
    title: 'Hyresavier',
    active_key: 'invoicebase',
    children: [
      {
        title: 'Alla',
        link: '#!/invoicebase/overview'
      },
      {
        title: 'Attestering',
        link: '#!/invoicebase/status/review',
        badge: {
          key: 'invoicebase_review'
        }
      },
      {
        title: 'Utestående',
        link: '#!/invoicebase/status/unpaid',
        badge: {
          key: 'invoicebase_unpaid'
        }
      },
      {
        title: 'Redo att skickas',
        link: '#!/invoicebase/status/ready',
        badge: {
          key: 'invoicebase_ready',
          color: 'warning'
        }
      },
      {
        title: 'Kräver åtgärd',
        link: '#!/invoicebase/status/error',
        badge: {
          key: 'invoicebase_error',
          color: 'danger'
        }
      },
      {
        title: 'Förfallna',
        link: '#!/invoicebase/status/overdue',
        badge: {
          key: 'invoicebase_overdue',
          color: 'danger'
        }
      }
    ]
  },
  {
    type: 'link',
    icon: 'fa-percent',
    title: 'Hyresjusteringar',
    link: '#!/rentadjustment/overview',
    active_key: 'rentadjustment'
  },
  {
    type: 'link',
    icon: 'fa-receipt',
    title: 'Tillägg & Avdrag',
    link: '#!/addon',
    active_key: 'addon'
  },
  {
    type: 'divider',
    name: 'Drift & Underhåll'
  },
  {
    type: 'collapsable',
    icon: icons.maintenance,
    title: 'Teknisk förvaltning',
    active_key: 'maintenance',
    children: [
      {
        title: 'Aktiviteter',
        link: '#!/maintenance/overview'
      },
      {
        title: 'Rutiner',
        link: '#!/maintenance/template/overview'
      }
    ]
  },
  {
    type: 'collapsable',
    icon: 'fa-chart-bar',
    title: 'Rapporter',
    active_key: 'report',
    children: [
      {
        title: 'Anpassad',
        link: '#!/report/create',
        icon: 'fas fa-plus'
      },
      {
        title: 'Fördefinierade',
        link: '#!/report/premade',
        icon: 'fas fa-star'
      },
    ]
  },
  {
    type: 'collapsable',
    icon: 'fa-envelope-open-text',
    title: 'Ärenden',
    active_key: 'ticket',
    children: [
      {
        title: 'Alla',
        link: '#!/ticket/overview'
      },
      {
        title: 'Pågående',
        link: '#!/ticket/status/open'
      },
      {
        title: 'Nya',
        link: '#!/ticket/status/new',
        badge: {
          key: 'ticket_new',
          color: 'primary'
        }
      }
    ]
  },
  {
    type: 'divider',
    name: 'Administration'
  },
  {
    type: 'collapsable',
    icon: 'fa-puzzle-piece',
    title: 'Integrationer',
    active_key: 'integration',
    children: [
      {
        title: 'Anslut',
        link: '#!/integration/create'
      },
      {
        title: 'Mina integrationer',
        link: '#!/integration/overview'
      },
    ]
  },
  {
    type: 'collapsable',
    icon: 'fa-cogs',
    title: 'Inställningar',
    active_key: 'setting',
    children: [
      {
        title: 'Abonnemang',
        link: '#!/setting/membership'
      },
      {
        title: 'Användare',
        link: '#!/setting/users'
      },
      {
        title: 'Hyresavisering',
        link: '#!/setting/job'
      },
      {
        title: 'Hyresgästportalen',
        link: '#!/setting/tenantportal'
      },
      {
        title: 'Objektstyper',
        link: '#!/setting/entitytypes'
      },
      {
        title: 'Profil',
        link: '#!/setting/user'
      },
      {
        title: 'Verksamhet',
        link: '#!/setting/billable'
      },
    ]
  },
  {
    type: 'collapsable',
    icon: 'fa-info-circle',
    title: 'Hjälp',
    active_key: 'help',
    children: [
      {
        title: 'Kontakta oss',
        link: '#!/help/contact'
      },
      {
        title: 'FAQ',
        link: '#!/help/faq'
      },
      {
        title: 'Om oss',
        link: '#!/help/about'
      }
    ]
  },
  {
    type: 'link',
    icon: 'fa-envelope',
    title: 'Meddelandehistorik',
    link: '#!/contact/messages',
    active_key: 'contact/messages'
  },
]
export { menu }
